module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_hair_makeup@2x-0842b187893c827ef3be4d7c26ae586b.webp";